import { FilterOperator, FilterPathType } from "domain/asset-management/assetFilterConstants";
import { AssetPathKey } from "domain/asset-management/assetPathMapping";
import { Asset, AssetDistributionRequest, AssetSearchRequest } from "services/asset-management/AssetService";

export const ERASURE_CERTIFICATES_PAGE_SIZE = 50;

const LAST_REPORT_UUID_PATH = "last_report_uuid";
const LAST_REPORT_S3_LINK_PATH = "last_report_s3_link";

export interface ErasureCertificateAsset {
    uuid: string;
    id: string;
    erasureState?: string;
    erasureDate?: string;
    reportUuid?: string;
    reportS3Link?: string;
}

export const buildErasureCertificateDistributionRequest = (
    pageNumber: number,
    viewRequest?: AssetSearchRequest
): AssetDistributionRequest => ({
    filters: [
        {
            name: AssetPathKey.LAST_ERASURE_STATE,
            value: "",
            operator: FilterOperator.EXIST,
            pathType: FilterPathType.KEYWORD,
        },
    ],
    viewRequest: {
        ...viewRequest,
        paths: [
            AssetPathKey.UUID,
            AssetPathKey.ASSET_ID,
            AssetPathKey.LAST_ERASURE_STATE,
            AssetPathKey.LAST_ERASURE_DATE,
            LAST_REPORT_UUID_PATH,
            LAST_REPORT_S3_LINK_PATH,
        ],
        size: ERASURE_CERTIFICATES_PAGE_SIZE,
        cursor: String(pageNumber - 1),
    },
});

const getStringValue = (asset: Asset, path: string): string | undefined => {
    const value = asset[path];
    return typeof value === "string" && value.trim().length > 0 ? value.trim() : undefined;
};

export const toErasureCertificateAssets = (assets: Asset[]): ErasureCertificateAsset[] =>
    assets.map((asset) => ({
        uuid: asset.uuid,
        id: asset.assetId,
        erasureState: getStringValue(asset, AssetPathKey.LAST_ERASURE_STATE),
        erasureDate: getStringValue(asset, AssetPathKey.LAST_ERASURE_DATE),
        reportUuid: getStringValue(asset, LAST_REPORT_UUID_PATH),
        reportS3Link: getStringValue(asset, LAST_REPORT_S3_LINK_PATH),
    }));
